import Image from "components/Elements/Image/Image";
import { ButtonA } from "components/Elements/Button/Button";
import { getAvailablePickerProjectsAmount } from "components/Pages/Inbox/helpers";
import { useContent } from "contexts/contentContext/contentContext";
import { useUser } from "contexts/userContext/userContext";

import styles from "./pickerPromoModals.module.scss";

const PickerPromoLimitProjectsModal = () => {
  const { getHtmlByKey, getTextByKey } = useContent();
  const { isBusiness, isPro } = useUser();

  const projectsAllowed = getAvailablePickerProjectsAmount(
    isPro(),
    isBusiness()
  );

  return (
    <div className={styles.limitModalContainer}>
      <div className={styles.sectionOne}>
        <Image name="oops-picker-limit" ext="png" className={styles.image} />
        <h3>{getHtmlByKey("picker-promo-limit-modal-title-one")}</h3>
        <p>
          {getHtmlByKey("picker-promo-limit-modal-text-one")} (
          <span>
            {projectsAllowed}/{projectsAllowed}
          </span>
          )
        </p>
        <div className={styles.footer}>
          <Image name="picker-logo-text" ext="png" />
        </div>
      </div>
      <div className={styles.sectionTwo}>
        <Image
          name="home/picker-promo-limit-banner"
          ext="png"
          className={styles.image}
        />
        <h3>{getHtmlByKey("picker-promo-limit-modal-title-two")}</h3>
        <p>{getHtmlByKey("picker-promo-limit-modal-text-two")}</p>
        <div className={styles.footer}>
          <ButtonA page="plans" target="_blank">
            {getTextByKey("upgrade-plan")}
          </ButtonA>
        </div>
      </div>
    </div>
  );
};

export default PickerPromoLimitProjectsModal;
